import { useRouter } from 'next/router'

import { AppLogo } from 'components/Icons/AppLogo'
import { Link as NavLink } from 'components/Link'
import { css } from 'styled-system/css'
import { Icon } from 'ui-kit/icon'
import { Link, LinkProps } from 'ui-kit/link'

const classes = css({
  display: 'inline-flex',
  gap: 2,
  fontWeight: 'medium',
  alignSelf: 'center',
})

export function BackToIntegrationAppLogo(props: Omit<LinkProps, 'end'>) {
  const { route } = useRouter()

  const isDocInWorkspace = route.startsWith('/w/[workspaceId]')

  if (!isDocInWorkspace)
    return (
      <Link href={'https://integration.app'} className={classes} {...props}>
        <Title />
      </Link>
    )

  return (
    <NavLink to={'/'} className={classes} {...props}>
      <Title />
    </NavLink>
  )
}

function Title() {
  return (
    <>
      <Icon width='8' height='6'>
        <AppLogo />
      </Icon>
      Integration.app
    </>
  )
}
